import autosize from 'autosize'
import { nextTick } from 'vue'

export const vAutosize = {
  mounted(el) {
    nextTick(() => {
      autosize(el)
    })
  },
  updated(el) {
    nextTick(() => {
      autosize.update(el)
    })
  },
  beforeUnmount(el) {
    autosize.destroy(el)
  },
}
